var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BTN_-_SHOW",
    "data-name": "BTN - SHOW",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SHOW"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "visibility_FILL1_wght400_GRAD0_opsz48",
    d: "M10.35,16.684a3.123,3.123,0,0,0,3.141-3.141A3.123,3.123,0,0,0,10.35,10.4a3.123,3.123,0,0,0-3.141,3.141,3.123,3.123,0,0,0,3.141,3.141Zm0-1.072a2.077,2.077,0,0,1-1.469-3.538,2.1,2.1,0,0,1,2.938,0,2.069,2.069,0,0,1-1.469,3.538Zm0,3.473A8.249,8.249,0,0,1,5.7,17.7a9.351,9.351,0,0,1-3.242-3.658.723.723,0,0,1-.083-.222,1.4,1.4,0,0,1,0-.554.723.723,0,0,1,.083-.222A9.351,9.351,0,0,1,5.7,9.386,8.249,8.249,0,0,1,10.35,8,8.249,8.249,0,0,1,15,9.386a9.351,9.351,0,0,1,3.242,3.658.723.723,0,0,1,.083.222,1.4,1.4,0,0,1,0,.554.723.723,0,0,1-.083.222A9.351,9.351,0,0,1,15,17.7,8.249,8.249,0,0,1,10.35,19.085Z",
    transform: "translate(1.65 -2)",
    opacity: 0.91
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.47846a308d5cd36b181dfe00f0fef0a8.svg";
export { ForwardRef as ReactComponent };